import React from "react";

const DATAPOINT_LABELS = {
  scope1_emissions: "Scope 1 emissions",
  scope2_emissions: "Scope 2 emissions",
  scope3_emissions: "Scope 3 emissions",
  renewable_energy_percent: "Renewable energy %",
  total_staff_headcount: "Number of employees",
  total_annual_production: "Total annual production",
  total_hazardous_waste_generated_tonnes: "Hazardous waste generated",
  total_non_hazardous_waste_generated_tonnes: "Non-hazardous waste generated",
  percent_solid_waste_recycled_reused_recovered: "% Waste recycled",
  total_water_consumed_m3: "Total water consumption",
  total_wastewater_generated_m3: "Total wastewater generated",
  percent_wastewater_recycled: "% Wastewater recycled",
  water_usage: "Total water consumption",
  waste_generated: "Total waste generated",
};

export function humanizeDatapoint(key) {
  if (!key) return "—";
  if (DATAPOINT_LABELS[key]) return DATAPOINT_LABELS[key];
  return String(key)
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

function formatValue(row) {
  if (row?.value == null || row.value === "") return "—";
  return String(row.value);
}

function formatConfidence(verified) {
  if (verified == null || verified === "") return "—";
  if (typeof verified === "string") return verified;
  if (typeof verified === "object") {
    if (verified.confidence != null && verified.confidence !== "") {
      return String(verified.confidence);
    }
    if (verified.source_reference != null && verified.source_reference !== "") {
      return String(verified.source_reference);
    }
  }
  return "—";
}

export default function PeerExtractedTable({ rows, title }) {
  if (!Array.isArray(rows) || rows.length === 0) return null;
  const heading =
    title || `Benchmarking results (${rows.length})`;
  return (
    <div className="request-benchmark-results">
      <h4 className="request-benchmark-results__title">{heading}</h4>
      <div className="request-benchmark-results__wrap">
        <table className="request-benchmark-results__table">
          <thead>
            <tr>
              <th>Company</th>
              <th>Datapoint</th>
              <th>Value</th>
              <th>Unit</th>
              <th>Confidence</th>
              <th>Quote</th>
              <th>Source</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => {
              const quote = String(row.quote || "").trim();
              const quotePreview =
                quote.length > 120 ? `${quote.slice(0, 120)}…` : quote;
              return (
                <tr key={`${row.company}-${row.datapoint}-${i}`}>
                  <td>{row.company || "—"}</td>
                  <td>{humanizeDatapoint(row.datapoint)}</td>
                  <td>{formatValue(row)}</td>
                  <td>{row.unit || "—"}</td>
                  <td>{formatConfidence(row.verified)}</td>
                  <td
                    className="request-benchmark-results__quote"
                    title={quote || undefined}
                  >
                    {quotePreview || "—"}
                  </td>
                  <td>
                    {row.source_url ? (
                      <a
                        href={row.source_url}
                        target="_blank"
                        rel="noreferrer"
                      >
                        Source
                      </a>
                    ) : (
                      "—"
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
